import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import moment from 'moment-timezone'

import LogAPI from 'api/LogAPI'

import DashboardList from 'lists/DashboardList'

import styles from './index.css'

@withRouter
export default class Dashboard extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)
  }

  state = {
    log : []
  }

  async fetchLog() {
    this.setState({ loading: true })
    const {response} = await LogAPI.list()
    this.setState({ log : response })
    this.setState({ loading: false })
  }

  componentDidMount() {
    this.fetchLog()
  }

  render() {
    return (
      <div className={styles.Page}>
        <DashboardList log={this.state.log} loading={this.state.loading} />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.jsx